import { Availability } from '@availability/const';
import { StateUtils } from '@spartacus/core';
import { AVAILABILITY } from '../availability-state';

export const LOAD_AVAILABILITY = '[CustomCatalog] Availability load';
export const LOAD_AVAILABILITY_SUCCESS = '[CustomCatalog] Availability load success';
export const LOAD_AVAILABILITY_FAIL = '[CustomCatalog] Availability load fail';
export const RESET_AVAILABILITY = '[CustomCatalog] Reset availability';

export const getAvailabilityKey = (productCode: string, unitCode: string): string => `${productCode}_${unitCode}`;

export class LoadAvailability extends StateUtils.EntityLoadAction {
  readonly type = LOAD_AVAILABILITY;

  constructor(
    public productCode: string,
    public unitCode: string,
    public quantity: number,
  ) {
    super(AVAILABILITY, getAvailabilityKey(productCode, unitCode));
  }
}

export class LoadAvailabilityFail extends StateUtils.EntityFailAction {
  readonly type = LOAD_AVAILABILITY_FAIL;

  constructor(
    public productCode: string,
    public unitCode: string,
    public quantity: number,
    payload: any,
  ) {
    super(AVAILABILITY, getAvailabilityKey(productCode, unitCode), payload);
  }
}

export class LoadAvailabilitySuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_AVAILABILITY_SUCCESS;

  constructor(
    public productCode: string,
    public unitCode: string,
    public quantity: number,
    public payload: Availability,
  ) {
    super(AVAILABILITY, getAvailabilityKey(productCode, unitCode), payload);
  }
}

export class ResetAvailability extends StateUtils.EntityRemoveAllAction {
  readonly type = RESET_AVAILABILITY;

  constructor() {
    super(AVAILABILITY);
  }
}

export type AvailabilityAction = LoadAvailability | LoadAvailabilityFail | LoadAvailabilitySuccess | ResetAvailability;
